import { ENV } from "../utils";

export class ApprovalConfig {
  baseApi = ENV.BASE_API;

  async getConfig(accessToken, siteId) {
    const response = await fetch(`${this.baseApi}/approval-config/${siteId}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async upsertConfig(accessToken, siteId, data) {
    const response = await fetch(`${this.baseApi}/approval-config/${siteId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
